var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"menu-a","d":"M21,19 L21,21 L3,21 L3,19 L21,19 Z M21,11 L21,13 L3,13 L3,11 L21,11 Z M21,3 L21,5 L3,5 L3,3 L21,3 Z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"menu-b","fill":"currentColor","key":0},React.createElement("use",{"xlinkHref":"#menu-a"})),React.createElement("use",{"fill":"currentColor","fillRule":"nonzero","xlinkHref":"#menu-a","key":1}),React.createElement("g",{"fill":"currentColor","mask":"url(#menu-b)","key":2},React.createElement("rect",{"width":"24","height":"24"}))])]);
}

HamburgerInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
